import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SERVER_API_URL} from 'app/app.constants';
import {IFranchise, Franchise} from 'app/blocks/model/franchise.model';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class FranchiseService extends EntityCrudService<IFranchise> {
    constructor(http: HttpClient) {
        super(http, Resource.FRANCHISES, (obj?) => new Franchise(obj));
    }

    getAllFranchises(): Promise<any> {
        const REQUEST_URI = `${SERVER_API_URL}api/franchises`;
        return this.http.get(REQUEST_URI).toPromise();
    }

    getFranchise = (franchiseId: any): Promise<any> => {
        return this.http
            .get(`${SERVER_API_URL}api/franchises/${franchiseId}`, {
                observe: 'response'
            })
            .toPromise();
    };
}
